/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

 import React, { PureComponent, Component } from "react";
 import { Dropdown, Form, Button, Icon, Popup } from "semantic-ui-react";
 import _ from "lodash";
 
 export class SearchTabDropDown extends Component {
   constructor() {
     super();
     this.state = {};
   }
   shouldComponentUpdate(nextProps, nextState) {
    
        let rerender= (JSON.stringify(nextProps.text) != JSON.stringify(this.props.text)||
        JSON.stringify(nextProps.search) != JSON.stringify(this.props.search)||
        JSON.stringify(nextProps.errors) != JSON.stringify(this.props.errors))||
        JSON.stringify(nextProps.disabled) != JSON.stringify(this.props.disabled)
        return rerender;
      }
     errorPopup = (errors) => {
       const error = errors.map((info, index) => {
         return (
           <div className="error" key={index}>
             * {info}
           </div>
         );
       });
       return (
         <Popup
           trigger={<Icon name="warning sign" color="red" />}
           content={error || ""}
         />
       );
     };
   getDropDownText = (option) => {
     let displayText = option;
     // console.log("getDropDownText() "+option);
     if (option.stringVal) {
       // If there is a stringVal, use that
       displayText = option.stringVal;
     } else {
       if (option.id && option.description) {
         displayText = option.id + " - " + option.description;
       } else if (option.id && option.value) {
         displayText = option.id + " - " + option.value;
       } else if (option.description) {
         displayText = option.description;
       } else if (option.id) {
         displayText = option.id;
       }
     }
     if (typeof displayText === "string") {
       return displayText.replace(/_/g, " ");
     }
     return displayText;
   };
 
   getDropDownText2 = (option) => {
     let displayText = option;
     // console.log("getDropDownText2() "+option);
 
     if (option.stringVal) {
       // If there is a stringVal, use that
       displayText = option.stringVal;
     } else {
       if (option.value && option.text && option.description) {
         displayText = option.text;
       } else if (option.value && option.text) {
         displayText = option.value + " - " + option.text;
       } else if (option.text) {
         displayText = option.text;
       }
     }
     if (typeof displayText === "string") {
       return displayText.replace(/_/g, " ");
     }
     return displayText;
   };
 
   getDropDownValue = (option) => {
     if (option.stringVal) {
       // If there is a stringVal, use that
       return option.stringVal;
     } else {
       // If not stringVal, it is likely a Master
       if (option.id) {
         // If master (ie there is an id), return the id
         return option.id;
       } else if (option.value) {
         // If master (ie there is an value), return the value
         return option.value;
       }
     }
     // If no matches were found
     return option;
   };
 
   handleChange = (e, { value }) => {
     this.props.onChange(value);
     document.getElementsByClassName("active-label")[0] &&
       document
         .getElementsByClassName("active-label")[0]
         .classList.remove("active-label");
     // this.props.onChange(
     //   this.props.data && this.props.data.find(obj => obj.description === value)
     //     ? this.props.data.find(obj => obj.description === value).id
     //     : value
     // )
   };
 
   onKeyPress = (e) => {
     if(!e.currentTarget.children)alert("ERROR WITH DROPDOWN COMPONENT")
     this.props.onKeyPress(e.currentTarget.children[0].value)
     document.getElementsByClassName('active-label')[0] &&
       document
         .getElementsByClassName('active-label')[0]
         .classList.remove('active-label')
   }
   render() {
     const {
       label,
       className,
       columnClassName,
       width,
       data,
       disabled,
       direction,
       labelClassName,
       centerSelect,
       onChange,
       text,
       onBlur,
       id,
       onButtonClick,
       onKeyPress,
       button,
       handleFocus,
       labelIcon,
       setINPUTID,
       shipmentId,
       penClicked,
       errors,
       multiple,
       boxNumber,
       isFooterLabel,
       mandatory,
       search
     } = this.props;
 
     let drop_data = data === undefined ? [] : data;
     let dpText = this.getDropDownText;
     if (
       className &&
       (className.includes("cbsa-us-exit-port") ||
         className.includes("cbsa-location-of-goods") ||
         className.includes("cbsa-country-of-export") ||
         className.includes("cbsa-package-level-code") ||
         className.includes("cbsa-office-number") ||
         className.includes("cbsa-country-of-origin") ||
         className.includes("cbsa-place-of-export") ||
         className.includes("cbsa-mode-of-transhipment"))
     ) {
       dpText = this.getDropDownText2;
     }
     // console.log("drop_data ",drop_data)
     let options = _.map(drop_data, (item, index) => ({
       key: index,
       text: dpText(item),
       value: this.getDropDownValue(item),
       description: item.description,
     }));
     // console.log("options ",options)
     return (
       <React.Fragment>
         <Form.Field
           width={width}
           className={`floating-select ${
             centerSelect && "floating-select-center"
           } ${columnClassName || ""}`}
         >
           {/* {(label || !isFooterLabel)&& (
             <label
               id={`${id}label`}
               htmlFor='floatField'
               className={'label-dropdown name-label es ' + labelClassName || ''}
             >
               {error && this.errorPopup(error)}
               {boxNumber && <div className="ui black label input-box-number">{boxNumber}</div>}
               {label}
               {labelIcon && labelIcon}
             </label>
           )} */}
           {isFooterLabel === true ? (
             <label
               htmlFor="floatField"
               style={{ bottom: "-17px"  }}
               className={
                 labelClassName
                   ? "label-footer " + labelClassName
                   : "label-footer"
               }
             >
               {errors && errors.length ? this.errorPopup(errors) : ""}
               {label}
               {labelIcon && labelIcon}
             </label>
           ) : (
             <label
               id={`${id}label`}
               htmlFor="floatField"
               className={"label-dropdown name-label es " + labelClassName || ""}
               
             >
               {(errors && errors.length) ? this.errorPopup(errors) : ''}
               {boxNumber && (
                 <div className="ui black label input-box-number">
                   {boxNumber}
                 </div>
               )}
               {label}
               {labelIcon && labelIcon}
             </label>
           )}
           <Dropdown
             lazyLoad={true}
             closeOnChange
             selectOnBlur={false}
             scrolling
             search ={search}
             style={errors && errors.length > 0 ? {backgroundColor: "#fff6f6"} : null}
             multiple={multiple}
             selection
             options={options}
             onChange={onChange && this.handleChange}
             onKeyUp={onKeyPress && this.onKeyPress}
             title={text}
             text={text}
             value={text}
             id={id + shipmentId}
             name={id + shipmentId}
             direction={direction}
             disabled={disabled}
             small="true"
             className={className}
             onBlur={(e) => {
               onBlur && onBlur(e);
               document.getElementsByClassName("active-label")[0] &&
                 document
                   .getElementsByClassName("active-label")[0]
                   .classList.remove("active-label");
             }}
             onFocus={(event) => {
               event.target && event.target.setAttribute("autocomplete", "nope");
               let previousSibling = document.getElementById(id + shipmentId)
                 .previousSibling;
               document.getElementsByClassName("active-label")[0] &&
                 document
                   .getElementsByClassName("active-label")[0]
                   .classList.remove("active-label");
               previousSibling &&
                 previousSibling.classList &&
                 document
                   .getElementById(id + shipmentId)
                   .previousSibling.classList.add("active-label");
               handleFocus && handleFocus(event);
               // setINPUTID && setINPUTID(id + shipmentId)
             }}
             onMouseDown={(e) => {
               e.stopPropagation();
               // penClicked && penClicked(e)
             }}
           />
           {mandatory === true && (
             <Icon
               name="asterisk"
               style={{ position: "absolute", right: "-3px" }}
             />
           )}
           {button && (
             <Button
               basic
               color="blue"
               className="openButton"
               onClick={(e) => onButtonClick(e)}
             >
               {button}
             </Button>
           )}
         </Form.Field>
       </React.Fragment>
     );
   }
 }
 
 export default SearchTabDropDown;
 